import { fixFloat } from '@/helpers'
import { getOrderItemValue } from '@/utils/Company/Order/Item'

/**
 * Normalize order extra items.
 *
 * @param {Object} orderItem - The order item object
 * @param {Array} extraItems - The extra items array
 * @return {Array} The normalized extra items
 */
export function normalizeOrderItemExtraItems({ orderItem, extraItems = [] }) {
  return extraItems.map(extraItem =>
    normalizeOrderItemExtraItem({ orderItem, extraItem }),
  )
}

/**
 * Normalize the order extra item.
 *
 * @param {Object} orderItem - The order item object
 * @param {Array} extraItem - The extra item object
 * @return {Object} Normalized order extra item
 */
export function normalizeOrderItemExtraItem({ orderItem, extraItem }) {
  return {
    quantity: extraItem.defaultQuantity ?? 0,
    ...extraItem,
    get unitPrice() {
      const { price: value = 0 } = this

      return getOrderItemValue({ orderItem, value })
    },
    get totalPrice() {
      const { unitPrice, quantity } = this

      let totalPrice = unitPrice * quantity

      totalPrice = fixFloat(totalPrice)

      return totalPrice
    },
  }
}
